import api from './axios';
import type { ApiResponse, MemberCoupon, PointAuditHistoryItem, PaginatedResponse, MemberExpiringPointsResponse } from './types';

// Fetch available coupons for current member
export async function fetchMemberCoupons(): Promise<MemberCoupon[]> {
  const res = await api.get<ApiResponse<MemberCoupon[]>>('/api/member/coupons');
  const data = (res.data as any)?.data ?? (res.data as any);
  return (data || []) as MemberCoupon[];
}

// Fetch points audit history for current member (paginated)
export async function fetchPointsHistory(page = 0, size = 20): Promise<PaginatedResponse<PointAuditHistoryItem>> {
  const res = await api.get<PaginatedResponse<PointAuditHistoryItem>>('/api/member/points/history', {
    params: { page, size },
  });
  // Some backends may wrap with ApiResponse
  const payload = (res.data as any)?.content ? (res.data as any) : (res.data as any)?.data;
  return payload as PaginatedResponse<PointAuditHistoryItem>;
}

// Fetch expiring points summary for a specific member (staff endpoint)
export async function fetchExpiringPoints(userId: string): Promise<MemberExpiringPointsResponse | null> {
  if (!userId) return null;
  const res = await api.get<MemberExpiringPointsResponse | ApiResponse<MemberExpiringPointsResponse>>('/api/member/points/expiring');
  const data = (res.data as any)?.expiring || (res.data as any)?.data?.expiring ? (res.data as any) : (res.data as any)?.data;
  return data
    ? {
        totalPointAmount: (data.totalPointAmount ?? 0) as number,
        expiring: Array.isArray(data.expiring) ? (data.expiring as any) : [],
        lots: Array.isArray(data.lots) ? (data.lots as any) : [],
      }
    : null;
}
